import { createTabs } from '@vfde-brix/ws10/tabs';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

export const mountTabs = (id: HtmlId) =>
    createComponentById(createTabs, id, NO_PATTERN_BUSINESS_LOGIC);
